import { useAuth } from '../../contexts/AuthContext';
import { Bookmark, Images, LogOut, PersonStanding, ScanSearch, Shirt, Tag, Users } from 'lucide-react';

export type AppView = 'tagging' | 'body' | 'dress' | 'gallery' | 'locate' | 'brand' | 'appearance';

interface HeaderProps {
  view: AppView;
  onChangeView: (view: AppView) => void;
}

const NAV: { id: AppView; label: string; icon: typeof Tag }[] = [
  { id: 'tagging', label: '打标', icon: Tag },
  { id: 'body', label: '人模', icon: PersonStanding },
  { id: 'dress', label: '试穿', icon: Shirt },
  { id: 'gallery', label: '作品', icon: Images },
  { id: 'locate', label: '衣服定位', icon: ScanSearch },
  { id: 'brand', label: '品牌特征定位', icon: Bookmark },
  { id: 'appearance', label: '外观差异', icon: Users },
];

export function Header({ view, onChangeView }: HeaderProps) {
  const { user, logout } = useAuth();

  return (
    <header className="h-14 border-b border-[var(--line)] bg-[var(--paper)] flex items-center justify-between px-4 shrink-0 shadow-[var(--shadow)]">
      <div className="flex items-center gap-3 min-w-0">
        <div className="font-semibold tracking-tight text-[var(--ink)] shrink-0">Stylist Compose</div>
        <nav className="flex items-center gap-1 ml-3 overflow-x-auto">
          {NAV.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => onChangeView(id)}
              className={`btn-ghost text-sm ${view === id ? 'bg-[var(--accent-soft)] text-[var(--ink)]' : 'text-[var(--muted)]'}`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}
        </nav>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {user?.avatar && (
          <img
            src={user.avatar}
            alt={user.displayName || user.username}
            className="w-7 h-7 rounded-full object-cover border border-[var(--line)]"
          />
        )}
        <span className="text-sm text-[var(--text)] hidden sm:inline">
          {user?.displayName || user?.username}
        </span>
        <button onClick={logout} className="btn-ghost text-[var(--muted)]" title="退出">
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
}
